/**
 * This class handles all LUX (Real user monitoring provider) calls.
 *
 * Usage: `context.$trackers.lux.addData('example', 1)`
 *
 * @see https://support.speedcurve.com/docs/using-js-rum-api
 *
 * @class      LuxService (name)
 * @hideconstructor
 */
export class LuxService {
  /**
   * Pushes an event to Speedcurve LUX.
   *
   * @param      {string}  label      The event's label.
   * @param      {string}  [value='']  The event's value.
   */
  addData(label, value = '') {
    try {
      if (typeof window.LUX != 'undefined' && window.LUX) {
        window.LUX.addData(label, value);
      }
    } catch (e) {
      console.log(e);
    }
  }
}
